import React, { useEffect, useLayoutEffect } from 'react';
import { Link } from "react-router-dom"
import './about.scss'
import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import Contact from '../../Components/Contact/Contact';

function About() {
    //page title
    useEffect(() => {
        document.title = 'Aprameya Shankar: About';
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.scrollTo(0, 0);
    });
    // mobile tab bar height adjustment
    useEffect(() => {
        const isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
        if(isTouch || window.innerWidth<=500){
            document.querySelector(".page-hero").style.height = "calc(100vh - 50px)"    
            document.querySelector(".black-pulldown").style.display = "none !important";
        }
    }, [])
    //black pulldown anim
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".black-pulldown", {
            scrollTrigger: {
                trigger: ".main-dark",
                scrub: true,
                // toggleActions: "restart none reverse pause"
            },
            scaleY: 2,
            // duration: 0.1,
        })
        gsap.to('.page-hero-wrapper', {
            scrollTrigger: {
                trigger: ".main-dark",
                scrub: true,
            },
            autoAlpha: 0,
            opacity: 0
        })
    }, [])
    //text glow
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const texts = gsap.utils.toArray(".text-glow")
        texts.forEach((text) => {

            gsap.to(text, {
                scrollTrigger: {
                    trigger: text,
                    toggleActions: "restart none resume reset",
                    start: "top 55%",
                    end: "bottom 60%"
                },
                autoAlpha: 0.96,
            })
        })
    }, [])
    //link cursor
    useLayoutEffect(() => {
        const cursor = document.querySelector(".cursor")
        const certificateLinks = document.querySelectorAll(".glow-link")
    
        certificateLinks.forEach((link) => {
          link.addEventListener("mouseover", () => {
                    cursor.style.scale = "1"
                    cursor.style.display = "block"
                })
                link.addEventListener("mouseout", () => {
                    cursor.style.scale = "0"
                })
            })
    })
    //hero animation
    useEffect(() => {
        const split = new SplitType('.h-t')
        // clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
        gsap.from('.h-t-1 .char', {
            duration: 0.3,
            y: '126',
            stagger: 0.06
        })
        gsap.to('.h-t-2', {
            duration: 0.7,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            delay: 0.55
        })
        gsap.from('.h-t-3 .char', {
            duration: 0.3,
            y: '126',
            stagger: 0.06,
            delay: 1.16,
        })
        gsap.to('.h-t-4', {
            duration: 0.7,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            delay: 1.75
        })
        gsap.from('.h-t-4 .char', {
            duration: 0.3,
            y: '126',
            stagger: 0.06,
            delay: 2.3
        })

    })
    

    return <>
        <div className='noise-div'></div>
        <div className="wrapper workpage-wrapper">
            <div className='black-pulldown'></div>
            <section className='page-hero'>
                <div className='page-hero-wrapper'>
                    <div className='h-top hero-text'>
                        <h1>
                            <span className='h-t h-t-1'>ABOUT</span><br/>
                            <span className='h-t blank-h-t h-t-2' style={{color: "transparent"}}>________-</span>
                        </h1>
                    </div>
                    <div className='h-bottom hero-text'>
                        <h1>
                            <span className='h-t h-t-3'>ME</span><br/>
                            <span className='h-t blank-h-t h-t-4' style={{color: "transparent"}}>____-</span>
                        </h1>
                    </div>
                    <div className='scroll-down'>
                        <span className='arrow'>↓</span><br/>
                        <span>scroll</span>
                    </div>
                </div>
            </section>
            <div className='main main-dark'></div>
            <section id='about-section'>
            <div className='about-section-wrapper'>
                <p className='brief-about-text'>
                    <span className='text-glow glow-1'>
                        I'm a Full-Stack Web Developer focused on writing
                    </span>
                    <span className='text-glow glow-2'>
                        clean,elegant,<br/>and efficient code. I
                    </span>
                    <span className='text-glow glow-3'>
                        have always been
                    </span>
                    <span className='text-glow glow-4'>
                        excited about the
                    </span>
                    <span className='text-glow glow-5'>
                        entire development spectrum. 
                    </span>
                    <br/>
                    <span className='text-glow glow-6'>
                        Right now, you can find me building projects, studying for
                    </span>
                    <span className='text-glow glow-7'>
                        tests ;), or hacking away DSA problems. 
                    </span>
                    {/* <span className='text-glow glow-8'>
                        I'm also known to
                    </span>
                    <span className='text-glow glow-9'>
                         dabble in Solidity and Blender
                    </span>
                    <span className='text-glow glow-10'>
                        from time to time.
                    </span> */}
                    <br/>
                    <span className='text-glow glow-11'>
                       I'm pursuing a 
                    </span>
                    <span className='text-glow glow-12'>
                        Bachelor of Technology degree in
                    </span>
                    <span className='text-glow glow-13'>
                        Computer Science at
                    </span>
                    <span className='text-glow glow-14'>
                        Siddaganga Institute of Technology. Having a solid academic background, I believe I
                    </span>
                    <span className='text-glow glow-15'>
                        can pour my <Link className='glow-link' to={'/skills'}>skills</Link>
                    </span>
                    <span className='text-glow glow-16'>
                        and energy into the field of computer
                    </span>
                    <span className='text-glow glow-17'>
                        science with my 
                    </span>
                    <span className='text-glow glow-18'>
                        distinguishing trait
                    </span>
                    <span className='text-glow glow-19'>
                        of creativity. Interested in working
                    </span>
                    <span className='text-glow glow-20'>
                        on ambitious projects with positive people.
                    </span>
                            
                </p>
            </div>
        </section>
            <div className='fade-flag'></div>    
            <Contact />       
        </div>
    </>

  
}
export default About